import './App.css';
import './styles/pages/MobileInputZoomFix.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { secureAllCookies } from './utils/cookieUtils';
import { monitorCSP } from './utils/cspMonitor';
import gtmService from './utils/gtmService'; // Import GTM service
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import OtpVerification from './pages/OtpVerification';
import AddDetails from './pages/AddDetails';
import UploadPhoto from './pages/UploadPhoto';
import SharePoster from './pages/SharePoster';
import TermsAndConditions from './pages/TermsAndConditions';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';

function App() {
  // Apply security enhancements
  useEffect(() => {
    // Secure all cookies to comply with security best practices
    secureAllCookies();
    
    // Monitor CSP violations to identify and fix issues
    monitorCSP();
    
    // Initialize GTM tracking
    gtmService.trackPageView('app_initialization', 'L&T Finance Poster App', window.location.pathname);
    
    // Track application load
    gtmService.trackUserJourney('app_loaded', {
      user_agent: navigator.userAgent,
      screen_resolution: `${window.screen.width}x${window.screen.height}`,
      is_mobile: window.innerWidth <= 768
    });

    // Debug GTM status in development
    if (process.env.NODE_ENV === 'development') {
      setTimeout(() => {
        gtmService.debug();
      }, 3000);
    }
  }, []);
  
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          {/* Protected routes that require OTP verification */}
          <Route path="/add-details" element={
            <ProtectedRoute>
              <main className="main-content">
                <AddDetails />
              </main>
            </ProtectedRoute>
          } />
          
          <Route path="/upload-photo" element={
            <ProtectedRoute>
              <main className="main-content">
                <UploadPhoto />
              </main>
            </ProtectedRoute>
          } />
          
          <Route path="/share-poster" element={
            <ProtectedRoute>
              <main className="main-content">
                <SharePoster />
              </main>
            </ProtectedRoute>
          } />
          
          {/* Public routes that don't require OTP verification */}
          <Route path="/otp-verification" element={
            <main className="main-content">
              <OtpVerification />
            </main>
          } />
          
          <Route path="/" element={
            <main className="main-content">
              <LandingPage />
            </main>
          } />
          
          {/* Terms and Conditions page */}
          <Route path="/terms-and-conditions" element={
            <main className="main-content">
              <TermsAndConditions />
            </main>
          } />
          
          {/* Admin Panel Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          
          {/* 404 Not Found route - must be last */}
          <Route path="*" element={
            <main className="main-content">
              <NotFound />
            </main>
          } />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
